<template>
    <div>
        <template v-if="evento.place_obj && evento.place_obj.tipo_svg_taquilla == 2 && evento.place_obj.tipo_proceso_taquilla == 3">
            <MapaGeneral
                :key="`mapaGeneral-${pasoUnoKey}`"
                :recinto_id="evento.place_obj.id" :paso_activo="paso_general_activo" :asientos_maximos="evento.asientos_maximos" :loading="loadingPasoDos" @updateLoading="(estado) => loadingPasoDos = estado" @goTo="finalizarPasoDos"
            />
        </template>
        <template v-else>
            <transition name="fade" mode="out-in">
                <div key="1" v-if="paso === 1" id="paso-1">
                    <SeleccionarZonaComponent
                        :key="`pasoUno-${pasoUnoKey}`"
                        v-if="evento && evento.tiene_recinto"
                        class="col-12"
                        :evento="evento"
                        :mode="mode"
                        :sesion_id="sesion.id"
                        @getZonasFormateadas="getZonasFormateadas"
                        @goTo="finalizarPasoUno"
                    />
                </div>
                <div key="2" v-if="paso >= 2" class="mt-3" id="paso-2">
                    <PasoDosComponent
                        v-if="(zona_seleccionada && zona_seleccionada.tiene_plazas === 0) || !evento.tiene_recinto"
                        :key="`pasoDos-${pasoDosKey}`"
                        :evento="evento"
                        :sesion="sesion"
                        :zona="zona_seleccionada"
                        :zonas_formateadas="zonas_formateadas"
                        :datos_compradores="datos_compradores"
                        :recinto="recinto"
                        :entradas="entradas"
                        :puede_cambiar="true"
                        :allow_blocked_seats="true"
                        :dia_abonado="false"
                        :place="evento.place_obj"
                        :mode="mode"
                        :disableInput="disableInput"
                        :bloquearPasoDos="bloquearPasoDos"
                        @resetDatos="resetDatos"
                        @goTo="finalizarPasoDos"
                        @actualizarEntradas="resetPaso3"
                    />
                    <PasoDosRAComponent
                        v-else
                        :zona="zona_seleccionada"
                        :key="`pasoDosRA-${pasoDosKey}`"
                        :datos_compradores="datos_compradores"
                        :recinto="evento.place_obj"
                        :asientos_maximos="evento.asientos_maximos"
                        :bloquearPasoDos="bloquearPasoDos"
                        @goTo="finalizarPasoDos"
                        @reset="resetPasoDosRA"
                        @cambiarPaso="(paso, reiniciar) => { $emit('cambiarPaso', paso, reiniciar) }"
                    />
                </div>
            </transition>
        </template>
        <div v-if="loadingPasoDos" id="loadingPasoDos" class="col-12 text-center" style="margin-top:20px; padding-bottom: 550px;">
            <LoaderComponent/>
        </div>
        <VisibilidadReducida :zona="zona_seleccionada" @aceptar="AceptarVisibilidadReducida"/>
        <transition name="fade" mode="out-in">
            <div key="3" v-if="paso >= 3" class="mt-3" id="paso-3">
                <PasoTresComponent
                    :evento="evento"
                    :event_id="evento.id"
                    :sesion_id="sesion.id"
                    :carrito_id="carrito_id"
                    :datos_compradores="datos_compradores"
                    :entradas_seleccionadas="entradas"
                    :solicitar_datos="evento.solicitar_datos"
                    :disableInput="disableInput"
                    @volver="volver"
                    @goTo="finalizarPasoTres"
                />
            </div>
        </transition>
        <div v-if="loadingPasoTres" id="loadingPasoTres" class="col-12 text-center" style="margin-top:20px; padding-bottom: 550px;">
            <LoaderComponent/>
        </div>
        <transition name="fade" mode="out-in">
            <div key="4" v-if="paso >= 4" class="mt-3" id="paso-4">
                <PasoCuatroComponent
                    :mode="mode"
                    :recinto="recinto"
                    :evento="evento"
                    :datos_compra="datos_compra"
                    :email="email"
                    :carrito_id="carrito_id"
                    @volverAtras="goTo(3)"
                    @goTo="goTo"
                />
            </div>
        </transition>
    </div>
</template>

<script>
    import SeleccionarZonaComponent from '@/components/backend/stepper/components/SeleccionarZonaComponent';
    import PasoDosComponent from '@/components/backend/stepper/eventos/PasoDosComponent.vue';
    import PasoTresComponent from '@/components/backend/stepper/eventos/PasoTresComponent.vue';
    import PasoCuatroComponent from '@/components/backend/stepper/eventos/PasoCuatroComponent.vue';
    import VisibilidadReducida from '@/components/backend/stepper/eventos/Modal/VisibilidadReducida.vue';
    import PasoDosRAComponent from '@/components/backend/stepper/eventos/PasoDosRAComponent.vue';
    import MapaGeneral from '../../components/MapaGeneral.vue';

    export default {
        props: ['evento', 'sesion', 'recinto', 'entradas', 'paso', 'mode'],
        data() {
            return {
                datos_compradores: [],
                zona_seleccionada: null,
                datos_compra: null,
                zonas_formateadas: [],
                zona_id: null,
                zonas: null,
                paso_general_activo: true,
                loadingPasoDos: false,
                loadingPasoTres: false,
                bloquearPasoDos: false,
                tipo_general: false,
                pasoUnoKey: 0,
                pasoDosKey: 0,
                disableInput: false
            }
        },
        created() {
            if (!this.evento.tiene_recinto) {
                this.finalizarPasoDos(2, null);
            }
        },
        methods: {
            resetDatos(new_zona) {
                this.pasoDosKey += 1;
                this.datos_compradores = [];
                this.zona_seleccionada = new_zona;
            },
            getZonasFormateadas(zonas_formateadas) {
                this.zonas_formateadas = zonas_formateadas;
            },
            finalizarPasoUno(paso, zona) {
                if (paso >= 2) {
                    this.zona_seleccionada = zona;
                }

                if(zona.visibilidad_reducida){
                    this.$modal.show('visibilidad-reducida');
                }

                this.$emit('cambiarPaso', paso)

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            finalizarPasoDos(paso, datos, carrito_id, tipo_general) {
                this.loadingPasoDos = true
                this.$nextTick(() => {
                    this.scrollTo('#loadingPasoDos');
                });

                if (carrito_id) {
                    this.carrito_id = carrito_id;
                }

                if (datos) {
                    this.datos_compradores = datos;
                }

                if (!tipo_general) {
                    if (Array.isArray(this.entradas) && this.entradas.length > 0) {
                        for (var i = 0; i < this.entradas.length; i++) {
                            if (this.entradas[i].unidades > 0) {
                                for (var x = 0; x < this.entradas[i].unidades; x++) {
                                    this.datos_compradores.push({
                                        apellidos: '',
                                        asiento: {
                                            zona_nombre: 'General'
                                        },
                                        descuento: 0,
                                        dni: '',
                                        es_nuevo: true,
                                        nombre: '',
                                        precio: {
                                            descripcion: this.entradas[i].descripcion,
                                            gd: this.entradas[i].price_management_taquilla,
                                            gd_interno: this.entradas[i].price_management_taquilla_interno,
                                            price_management_taquilla: this.entradas[i].price_management_taquilla,
                                            id: this.entradas[i].id,
                                            precio: this.entradas[i].precio,
                                            precio_total: this.entradas[i].total_price
                                        },
                                        precios: [
                                            {
                                                descripcion: this.entradas[i].descripcion,
                                                gd: this.entradas[i].price_management_taquilla,
                                                gd_interno: this.entradas[i].price_management_taquilla_interno,
                                                id: this.entradas[i].id,
                                                precio: this.entradas[i].precio,
                                                price_management_taquilla: this.entradas[i].price_management_taquilla,
                                                precio_total: this.entradas[i].total_price
                                            }
                                        ],
                                        telefono: '',
                                        url_imprimir: null
                                    });
                                }
                            }
                        }
                    }
                    this.bloquearPasoDos = true;
                } else {
                    if (this.evento.place_obj && this.evento.place_obj.tipo_proceso_taquilla != 3) {
                        this.datos_compradores.forEach(comprador => {
                            comprador.asiento = {
                                zona_id: comprador.zona_id,
                                asiento: comprador.asiento,
                                fila: comprador.fila,
                                zona_nombre: comprador.zona_nombre
                            };
                        });
                    }

                    this.tipo_general = tipo_general;
                    this.paso_general_activo = false;
                }

                setTimeout(() => {
                    this.loadingPasoDos = false
                    this.$emit('cambiarPaso', paso)

                    this.$nextTick(function() {
                        this.$scrollTo('#paso-' + paso, 100);
                    });
                }, 1000);
            },
            finalizarPasoTres(paso, datos, email) {
                var datos_compra = null
                this.loadingPasoTres = true
                if(paso === 4){
                    this.disableInput = true;
                }
                this.$nextTick(() => {
                    this.scrollTo('#loadingPasoTres');
                });
                this.email = email;

                if (this.zona_seleccionada != null) {
                    datos_compra = {
                        evento_id: this.evento.id,
                        sesion_id: this.sesion.id,
                        zona_id: this.zona_seleccionada.id,
                        datos_compradores: this.datos_compradores,
                        metodo_pago: datos.metodo_pago,
                        modalidad: 0,
                        tipo: false,
                        concepto: datos.concepto,
                        enviar_email: datos.enviar_email,
                        email: datos.email,
                        nombre: datos.nombre,
                        telefono: datos.telefono,
                        cp: datos.cp,
                        visible: datos.visible ? 1 : 0,
                        recinto: true,
                        fecha_caducidad: datos.fecha_caducidad,
                        nombre_comprador: datos.nombre_comprador,
                        apellidos_comprador: datos.apellidos_comprador,
                        dni_comprador: datos.dni_comprador,
                        telefono_comprador: datos.telefono_comprador
                    };
                } else {
                    datos_compra = {
                        evento_id: this.evento.id,
                        sesion_id: this.sesion.id,
                        zona_id: 1,
                        datos_compradores: this.datos_compradores,
                        entradas: this.entradas,
                        metodo_pago: datos.metodo_pago,
                        modalidad: 0,
                        tipo: false,
                        concepto: datos.concepto,
                        enviar_email: datos.enviar_email,
                        email: datos.email,
                        nombre: datos.nombre,
                        telefono: datos.telefono,
                        cp: datos.cp,
                        visible: datos.visible ? 1 : 0,
                        recinto: this.tipo_general ? true : false,
                        fecha_caducidad: datos.fecha_caducidad,
                        nombre_comprador: datos.nombre_comprador,
                        apellidos_comprador: datos.apellidos_comprador,
                        dni_comprador: datos.dni_comprador,
                        telefono_comprador: datos.telefono_comprador
                    };
                }

                if (datos) {
                    this.datos_compra = datos_compra;
                }

                setTimeout(() => {
                    this.loadingPasoTres = false
                    this.$emit('cambiarPaso', paso)

                    this.$nextTick(function() {
                        this.scrollTo('#paso-' + paso);
                    });
                }, 1500);
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            resetPaso3() {
                if (this.paso >= 3) {
                    this.$emit('cambiarPaso', 2);
                    this.$nextTick(function() {
                        this.$emit('cambiarPaso', 3)
                    });
                }
            },
            goTo(paso, zona_id = null) {
                if (paso < this.paso) {
                    this.paso_general_activo = true;

                    if (paso === 1) {
                        this.entradas_seleccionadas = null;
                        this.datos_compra = [];
                        this.datos_compra.metodo_pago = [];
                        this.zona_seleccionada = [];
                        this.datos_compradores = [];
                        this.pasoUnoKey += 1;
                        this.entradas_seleccionadas = null;
                        this.bloquearPasoDos = false;
                        this.$emit('resetearEntradas',false);
                        localStorage.removeItem('zona_id');
                        this.$emit('cambiarPaso', 1);
                    }
                    if (paso === 2) {
                        if (zona_id) {
                            localStorage.setItem('zona_id', zona_id);
                            this.disableInput = false;
                        }
                        if (this.evento && this.evento.place_obj &&
                            this.evento.place_obj.tipo_svg_taquilla &&
                            this.evento.place_obj.tipo_svg_taquilla == 2 &&
                            this.evento.place_obj.tipo_proceso_taquilla == 3) {
                            this.pasoUnoKey += 1;
                        }

                        this.entradas_seleccionadas = null;
                        this.datos_compra = null;
                        this.datos_compradores = [];
                        this.bloquearPasoDos = false;
                        this.pasoDosKey += 1;
                        this.$emit('resetearEntradas', false);
                        this.$emit('cambiarPaso', 2);

                        if (!this.evento.tiene_recinto) {
                            this.finalizarPasoDos(2, null);
                        }
                    }

                    if (paso <= 3) {
                        this.disableInput = false;
                    }

                    this.$nextTick(function() {
                        this.$emit('cambiarPaso', paso)
                    });
                }
            },
            getContinuarEnZona() {
                const params = {
                    filters: {
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id,
                        taquilla: 1
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                    this.cargando = false;
                    this.$nextTick(() => {
                        this.$scrollTo('#mapa', 100);
                    })

                    this.$store.dispatch(this.config.getVuexAlias('zonas.anexas.index'), params).then(res => {
                        this.zonas = this.zonas.concat(res.data.data);

                        for(let zona_n in this.zonas) {
                            this.zonas_formateadas.push(Object.assign({}, this.zonas[zona_n]));
                            let disponible_n = this.zonas_formateadas[zona_n].precios.length > 0 && this.zonas_formateadas[zona_n].esta_disponible ? true : false;
                            this.zonas_formateadas[zona_n].esta_disponible = disponible_n;
                        }
                    });
                });
            },
            AceptarVisibilidadReducida(){
                this.$modal.hide('visibilidad-reducida');
            },
            borrarSesion() {
                const params = {
                    filters: {
                        session_id: this.carrito_id,
                        tid: this.configuracion.hash_teatro
                    },
                    session_id: this.carrito_id,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.sesion.delete'), params);
            },
            volver() {
                this.borrarSesion();
                this.goTo(1);
            },
            resetPasoDosRA() {
                this.pasoDosKey += 1;
                this.datos_compradores = [];
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        components: {
            SeleccionarZonaComponent, PasoDosComponent, PasoTresComponent, PasoCuatroComponent,
            VisibilidadReducida, PasoDosRAComponent, MapaGeneral
        }
    }
</script>
